import axios, { AxiosResponse } from 'axios'
import qs from 'qs'
import { getAuthCookie } from './services/auth'
import {
  UNKNOWN_NETWORK_ERROR,
  isControlledBackendError,
  isUnauthorizedError,
  isServerError
} from './custom-errors'

const authorizationHeader = () => 'Token ' + getAuthCookie()

function handleError(error) {
  // No backend response received
  if (!error.response) {
    error.message = UNKNOWN_NETWORK_ERROR
    throw error
  }
  // Request was made and the server responded with a status code 401
  if (isUnauthorizedError(error)) {
    error.message = 'Unauthorized user'
    parent.postMessage('logout', '*')
    throw error
  }
  // Request was made and the server responded with a status code 400
  if (isControlledBackendError(error)) {
    error.message = JSON.stringify(error.response.data)
    throw error
  }
  // Request was made and the server responded with a status code 500
  if (isServerError(error)) {
    error.message = `Server error ${error.response.status}`
    throw error
  }

  error.message = error.message + ' - ' + JSON.stringify(error.response.data)
  throw error
}

function run(config): Promise<AxiosResponse<any>> {
  return axios(config).catch(handleError) as Promise<AxiosResponse<any>>
}

const getDefaultConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: authorizationHeader()
  }
})

export function runUnauthenticatedJsonPost(url, data): Promise<AxiosResponse> {
  return run({
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url,
    data
  })
}

export function runUnauthenticatedJsonGet(url): Promise<AxiosResponse> {
  return run({
    headers: { 'Content-Type': 'application/json' },
    method: 'get',
    url
  })
}

export function runJsonPut(url, data): Promise<AxiosResponse> {
  return run({ ...getDefaultConfig(), method: 'put', url, data })
}

export function runJsonPost(url, data: any = {}): Promise<AxiosResponse> {
  return run({ ...getDefaultConfig(), method: 'post', url, data })
}

export function runJsonGet(url, query = null): Promise<AxiosResponse> {
  if (query) url += '?' + qs.stringify(query, { arrayFormat: 'comma' })
  return run({ ...getDefaultConfig(), method: 'get', url })
}
